export class PortalModel {   
    public backgroundImage:string;
    public backgroundVideo:string;
    public portalDescription:string;
}

